export class Markdown {
    constructor() { }

    public css() {
        return `/* light */
/* ✅ 전체 마크다운 스타일 */ 
.markdown-body {
  color-scheme: light;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
  font-size: 16px;
  line-height: 1.7;
  color: #1f2328;
  background-color: #ffffff;
  word-wrap: break-word;
}

/* ✅ 링크 스타일 */
.markdown-body a {
  color: #9ca3af;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
}
.markdown-body a:hover {
  text-decoration: underline;
}

/* ✅ 제목 (Heading) 스타일 */
.markdown-body h1 {
  font-size: 2rem;
  font-weight: 700;
  padding-bottom: 0.5rem;
  border-bottom: 3px solid #d1d5db;
  margin-bottom: 1rem;
}
.markdown-body h2 {
  font-size: 1.75rem;
  font-weight: 600;
  padding-bottom: 0.3rem;
  border-bottom: 2px solid #e5e7eb;
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
}
.markdown-body h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-top: 0.6rem;
  margin-bottom: 0.6rem;
}
.markdown-body h4 {
  font-size: 1.25rem;
  font-weight: 600;
}
.markdown-body h5 {
  font-size: 1.1rem;
  font-weight: 600;
}
.markdown-body h6 {
  font-size: 1rem;
  font-weight: 600;
  color: #9ca3af;
}

/* ✅ 코드 블럭 스타일 (더 연한 회색 테마 적용) */
.markdown-body pre {
  background: linear-gradient(135deg, #e5e7eb 0%, #f3f4f6 100%);
  color: #374151;
  padding: 1rem;
  border-radius: 10px;
  overflow: auto;
  font-size: 14px;
  line-height: 1.5;
  border-left: 4px solid #d1d5db; /* 연한 회색 포인트 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.markdown-body ol {
  padding-left: 0.8em;
  list-style-type: decimal; /* ✅ 숫자 리스트 스타일 추가 */
}
/* ✅ 코드 인라인 스타일 */
.markdown-body code {
  font-family: "Fira Code", monospace;
  font-size: 14px;
  background-color: #e5e7eb;
  border-radius: 6px;
  padding: 0.2em 0.4em;
  font-weight: 600;
}
.markdown-body pre code {
  background: transparent;
  padding: 0;
  border: none;
  color: #4b5563;
}

/* ✅ 인용문 스타일 */
.markdown-body blockquote {
  padding: 0.8em 1.2em;
  color: #9ca3af;
  background-color: #f3f4f6;
  border-left: 4px solid #d1d5db;
  font-style: italic;
  margin: 1rem 0;
  border-radius: 6px;
}

/* 1단계 ul li */
.markdown-body ul li {
  position: relative;
  padding-left: 1em;
  margin-top: 0.4em;
}

/* 1단계 불릿: ● */
.markdown-body ul:not(ul ul) > li::before {
  content: "●";
  color: #111827;
  font-size: 6px;
  font-weight: bold;
  position: absolute;
  left: 0;
  top: auto;
}

/* 2단계 불릿: ○ */
.markdown-body ul ul > li::before {
  content: "○";
  color: #6b7280;
  font-size: 5.5px;
  font-weight: normal;
  position: absolute;
  left: 0;
  top: 1.3em;
}

/* 3단계 이상 불릿: ▪ */
.markdown-body ul ul ul > li::before {
  content: "▪";
  color: #9ca3af;
  font-size: 5px;
  position: absolute;
  left: 0;
  top: 1.3em;
}
.markdown-body ol {
  padding-left: 1.8em;
}

.markdown-body li {
  margin-top: 0.4em;
}



/* ✅ 테이블 스타일 (연한 회색 계열 + 주제열 강조) */
.markdown-body table {
  margin-top: 1em;
  margin-bottom: 1em;
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
.markdown-body th {
  background: #9ca3af; /* 연한 회색 헤더 */
  color: #ffffff;
  font-weight: 600;
  padding: 12px;
  text-align: left;
}
.markdown-body td {
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
  transition: background 0.2s ease-in-out;
}

/* ✅ 표의 가장 좌측 주제열(첫 번째 열) 강조 */
.markdown-body td:first-child {
  background: #e5e7eb; /* 연한 회색 */
  font-weight: 600;
  color: #374151;
}

/* ✅ 체크리스트 스타일 (연한 회색 계열 적용) */
.markdown-body input[type="checkbox"] {
  margin: 0 0.5em 0.25em -1.4em;
  vertical-align: middle;
  appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid #9ca3af;
  border-radius: 3px;
  position: relative;
}
.markdown-body input[type="checkbox"]:checked {
  background-color: #9ca3af;
  border: none;
  position: relative;
}
.markdown-body input[type="checkbox"]:checked::after {
  content: "✔";
  color: white;
  position: absolute;
  font-size: 12px;
  top: 1px;
  left: 3px;
}

/* ✅ 기타 작은 요소들 조정 */
.markdown-body hr {
  border: none;
  height: 2px;
  background: linear-gradient(to right, #d1d5db, #9ca3af);
  margin: 1.5rem 0;
}

.markdown-body kbd {
  display: inline-block;
  padding: 0.2rem 0.4rem;
  font: 14px "Fira Code", monospace;
  color: #374151;
  background: #f3f4f6;
  border-radius: 6px;
  border: 1px solid #d1d5db;
}

`;
    }
}